"use client";

import React, { MouseEvent, useCallback } from "react";

import { useParams, useRouter } from "next/navigation";

import { GlobalPathParams } from "~/app/[locale]/types";
import { CombinedLink } from "~/components/combined-link/component";
import { Logo } from "~/components/logo/component";
import { LINKED_LOGO_CLASSES } from "~/components/logo/components/linked-logo/constants";
import { Routes } from "~/constants/request";
import { getLinkUrl } from "~/helpers/locales";

import { LinkedLogoContainer } from "./styled";
import { LinkedLogoProps } from "./types";

export const LinkedLogo: React.FC<LinkedLogoProps> = ({
  className,
  image,
  size,
  href = Routes.HOME,
  onClick,
}) => {
  const router = useRouter();
  const { locale } = useParams<GlobalPathParams>();

  const internalOnClick = useCallback(
    async (event: MouseEvent) => {
      event.preventDefault();
      if (onClick) {
        onClick();
      }

      return router.push(getLinkUrl(locale, href));
    },
    [onClick, router, href, locale],
  );

  return (
    <LinkedLogoContainer className={className} size={size}>
      <CombinedLink
        href={href}
        underline="none"
        className={LINKED_LOGO_CLASSES.logoLink}
        onClick={internalOnClick}
      >
        <Logo image={image} size={size} className={LINKED_LOGO_CLASSES.logoImage} />
      </CombinedLink>
    </LinkedLogoContainer>
  );
};
